<template>
    <component
        :is="isCardLayout ? 'card' : 'div'"
        v-show="numberOfVisibleQuestions || questionIsAlwaysVisible"
        class="wrapper-margin">
        <slot name="question" />
        <PersonWrapper
            v-for="(personKey, index) in personKeys"
            :key="personKey"
            :answers-by-persons="answersByPersons"
            :question="question"
            :person-key="personKey"
            :registrar-mode="registrarMode"
            :index="index"
            :show-names="!registrarMode && !!$slots?.persons"
            @event="$emit('event', $event)"
            @set-question-global-visibility-for-person="setQuestionGlobalVisibilityForPerson">
            <template #default="slotData">
                <slot
                    name="persons"
                    v-bind="slotData" />
            </template>
        </PersonWrapper>
    </component>
</template>

<script>
import PersonWrapper from "@/components/pages/registration/questions/PersonWrapper";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "QuestionWrapper",
    components: {PersonWrapper},
    mixins: [mainRegistrationMixin],
    props: {
        questionIsAlwaysVisible: {
            type: Boolean,
            default: false
        },
        isCardLayout: {
            type: Boolean,
            default: true
        },
        answersByPersons: {
            type: Object,
            required: true
        },
        question: {
            type: Object,
            required: true
        },
        registrarMode: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            globalVisibilityForPersons: {}
        }
    },
    computed: {
        numberOfVisibleQuestions() {
            let count = 0
            for (const prop in this.globalVisibilityForPersons) {
                if (this.globalVisibilityForPersons.hasOwnProperty(prop) && this.globalVisibilityForPersons[prop]) {
                    count++
                }
            }
            return count
        },
        personKeys() {
            if (this.registrarMode) {
                return ["registrar"]
            } else {
                return this.registrationData.participatingPersons
            }
        }
    },
    methods: {
        setQuestionGlobalVisibilityForPerson({personKey, isVisible = true}) {
            this.$set(this.globalVisibilityForPersons, personKey, isVisible)
        }
    }
}
</script>

<style lang="scss" scoped>
    .wrapper-margin {
        margin-bottom: $grid-gutter-width;
    }
</style>